import state from "@/store/modules/contract-expiration/state";
import actions from "@/store/modules/contract-expiration/actions";
import mutations from "@/store/modules/contract-expiration/mutations";
import getters from "@/store/modules/contract-expiration/getters";

export default {
  state,
  actions,
  mutations,
  getters
}